import React from "react";
import { useDispatch, useSelector } from "react-redux";
import sclogo from "../../../images/logo/sclogo.jpeg";
import { Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import { verifyTrainingCertificate } from "../../../actions/learning_provider/provider_user/training_action";
import LoadingOverlay from "react-loading-overlay";
import { Fragment } from "react";
const VerifyCertificate = () => {
  const { ref_no } = useParams();
  const state = useSelector((state) => state.puTrainingReducer);
  const dispatch = useDispatch("");
  useEffect(() => {
    dispatch(verifyTrainingCertificate({ ref_no: ref_no }));
  }, []);
  //const  ref_no="EDU-COM-COM-009";
  const link = "https://educloudlabs.com/certificate/verify/" + ref_no;
   return (
    <LoadingOverlay active={state.loading} spinner text="Loading...">
      <div>
        <div className="certificate-container center-cer">
          {state.verifyCertificate.username ? (
            <div className="certificate cer-back">
              <div className="water-mark-overlay"></div>
              <div className="certificate-body">
                <img src={sclogo} className="logo-img" /><br/>
                <i class="black-col"> a division of </i>{" "}
                <span class="word-color">EDUCLOUDLABS</span>
                <h2 className="certificate-title text-color">
                  <strong>Sagarconsultants in association with MLBI</strong>
                </h2>
                <h1 className="certifcate-hed">Certificate of completion</h1>
                <p className="certificate-small-head">
                  This certificate is presented to
                </p>
                <p className="student-name">
                  {state && state.verifyCertificate.username
                    ? state.verifyCertificate.username
                    : " "}
                </p>
                <div className="certificate-content">
                  <div className="about-certificate">
                    <p className="about-certificate-par">
                      For completing{" "}
                      <b>
                        {" "}
                        {state && state.verifyCertificate.training_name
                          ? state.verifyCertificate.training_name
                          : " "}
                      </b>{" "}
                      program from 18th April to 06th May 2023.
                    </p>
                  </div>
                </div>
                <p className="b-col dir-line"> __________________</p>              
                <strong className="b-col dir-name">Ajit Kshirsagar</strong>
                <p className="b-col dir-heading">Director</p>
                <span className="ref-no black-col">Ref No : {ref_no}</span>
                <a className="ref-link about-certificate-par black-col">
                  {link}
                </a>
              </div>
            </div>
          ) : (
            <div>
              {!state.loading && (
                <Fragment>
                  <h1 className="not-found-cer">NO Certificate Found </h1>
                  <Link to={"/"}>
                    <h1 className="not-found-cer">Contact To EDUCLOUDLABS </h1>
                  </Link>
                </Fragment>
              )}
            </div>
          )}
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default VerifyCertificate;
